<template>
  <div>
    <table-manager
      @filterChanged="filterChanged"
      @paginationChanged="paginationChanged"
      @ClickOnAddButton="showAdd"
      :options="options"/>

    <basic-table
      v-if="systemUsers"
      :items="systemUsers"
      :fields="systemUsersFields"
      :filter="filter"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows"
      :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedSystemUsers" :isEdit="isEdit"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      isEdit: null,
      systemUsersFields: [
        { key: 'user_id', label: this.$i18n.t('ID'), sortable: true },
        { key: 'login', label: this.$i18n.t('Login'), sortable: true },
        { key: 'ip4', label: this.$i18n.t('IPv4'), sortable: true },
        { key: 'ip6', label: this.$i18n.t('IPv6'), sortable: true },
        { key: 'actions', label: this.$i18n.t('Actions') }
      ],
      selectedSystemUsers: {
        login: '',
        sys_groups: []
      },
      options: {
        isShowAddButton: true
      },
      filter: '',
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.isEdit = false
      this.selectedSystemUsers = {
        login: '',
        password: '',
        ip4: '0.0.0.0',
        ip6: '::',
        token: '',
        sys_groups: [],
        mask4: 0,
        mask6: 0,
        is_rest_available: 1
      }
      this.$root.$emit('bv::show::modal', 'modalEditSystemUsers', '#btnShow')
    },
    editItem (item) {
      this.isEdit = true
      this.selectedSystemUsers = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditSystemUsers', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "User"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Users/DELETE_SYSTEM_USER', item.user_id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Users/GET_SYSTEM_USERS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    systemUsers () {
      return this.$store.getters['Users/SYSTEM_USERS'].filter(item => { return item.login.toUpperCase().includes(this.filter.toUpperCase()) })
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_SYSTEM_USERS')
    this.$store.dispatch('Users/GET_SYSTEM_USERS_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/systemUsers/main.vue